module.exports = __webpack_public_path__ + "img/PCMI_banner.05a3d265.png";